/**
 * Created by idea on 20/03/2017.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiIcheckService} from './ApiIcheck.service'

@Injectable()
export class PostService extends ApiIcheckService {
    constructor(http: Http, router: Router) {
        super(http, router);
        this.setEndPoint('/posts');
    }

    likePost(id,body:any){
        let url = `/posts/${id}/likes`;
        return this.post(url,body);
    }


    subscribePost(id:string|number,body:any){
        let url = `/posts/${id}/subscribe`;
        return this.post(url,body);
    }

    reportPost(id:string,body:{object_id:string|number,type_id:number,note?:string,object_type?:string},type?:string){
        let url = `/reports`;
        body.object_type = 'post';
        if(type == 'product'){
            body.object_type = 'product';
        }
        return this.post(url,body);
    }

    sharePost(body:any){
        let url = `/posts`;
        return this.post(url,body);
    }

    getReportType(type?:string,options?:any){
        let url = `/posts/report-types`;
        if(type=='product'){
            url = `/reports/types`;
        }
        return this.get(url,options);
    }

    deletePost(id:any){
        let url = `/posts/${id}/delete`;
        return this.delete(url);
    }

}


// WEBPACK FOOTER //
// /app/src/app/common/services/Post.service.ts